// components/TuneCardBox.js
import React from 'react';

export default function TuneCardBox({ children, onClick, style = {}, itemMode }) {
  return (
    <li
      className="card"
      data-item-mode={itemMode || undefined}
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {children}
    </li>
  );
}
